const ipaddr = require('ipaddr.js');
const { isEmpty, } = require('lodash');

const parseRange = (value) => {
  try {
    const [addressString] = value.split('/');
    // ipaddr.js は '12345' や '010.1.1.1'(8進数) もIPv4として解釈するため、ドット区切り10進数以外は弾く
    if(ipaddr.IPv4.isValid(addressString) && !ipaddr.IPv4.isValidFourPartDecimal(addressString)) return null;

    const [address, bits] = value.includes('/') ? ipaddr.parseCIDR(value) : [ipaddr.parse(value), null];
    const processedAddress = ipaddr.process(address.toString());
    const isIPv4Mapped = address.kind() === 'ipv6' && processedAddress.kind() === 'ipv4';
    return {
      address: processedAddress,
      bits: bits == null ? (processedAddress.kind() === 'ipv4' ? 32 : 128) : (isIPv4Mapped ? bits - 96 : bits),
    };
  } catch(e) {
    return null;
  }
};

const isValidIpAddressRange = (value) => {
  const range = parseRange((value || '').trim());
  return range != null && range.bits >= 0;
};

const normalizeIpAddressRange = (value) => {
  const range = parseRange((value || '').trim());
  if(range == null) return null;

  const { address, bits } = range;
  return bits === (address.kind() === 'ipv4' ? 32 : 128) ? address.toString() : `${address.toString()}/${bits}`;
};

const isAllowedIpAddress = (ip, allowedIpAddresses = []) => {
  const target = parseRange(ip || '');
  if(target == null) return false;

  return allowedIpAddresses.map(parseRange).filter(_ => _ != null).some(_ => _.address.kind() === target.address.kind() && target.address.match(_.address, _.bits));
};

const isIpRestricted = (ipRestrictionEnabled, allowedIpAddresses = []) => {
  return ipRestrictionEnabled === true && !isEmpty(allowedIpAddresses);
};

exports.isValidIpAddressRange = isValidIpAddressRange;
exports.normalizeIpAddressRange = normalizeIpAddressRange;
exports.isAllowedIpAddress = isAllowedIpAddress;
exports.isIpRestricted = isIpRestricted;
